export default __webpack_public_path__ + "static/media/pantry1-afterI-1024w.a21b3580.png";